/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { reconciliation_CandidateChildSummaryDTO } from './reconciliation_CandidateChildSummaryDTO';
export type reconciliation_DebtorAccountSummaryDTO = {
    children?: Array<reconciliation_CandidateChildSummaryDTO>;
    contactId?: string;
    displayName: string;
    familyGroupId?: string;
    id: string;
    type?: reconciliation_DebtorAccountSummaryDTO.type;
};
export namespace reconciliation_DebtorAccountSummaryDTO {
    export enum type {
        CONTACT = 'CONTACT',
        FAMILY_GROUP = 'FAMILY_GROUP',
    }
}

